import React, { Component, Fragment } from 'react';
import { connect } from 'react-redux';
import cn from 'classnames'
import last from 'lodash/last'
import moment from 'moment'
import { Modal, Tooltip } from '../../components';
import { getUserFullName } from '../../utils/utilsChat';
import {
  inflect,
  stringifyTimePeriod,
  exposeComponentToGlobalScope,
} from '../../utils/utilsGlobal';

import styles from './AnalyticsManualSwitchOff.scss';
import uiStyles from '../../styles/ui.scss';
import { getManualSwitchOffRecords } from '../../services/apiAnalytics';


const mapStateToProps = state => {
  return {
    currentCompany: state.currentCompany,
  };
};

@connect(mapStateToProps)
export class AnalyticsManualSwitchOff extends Component {

  state = {
    records: [],
    hasLoadedAllRecords: false,
  };

  RECORD_CHUNK_SIZE = 20;

  componentDidMount(){
    this.getRecords(this.RECORD_CHUNK_SIZE, null).then(rawRecords => {
      const records = this.processRecords(rawRecords);
      this.setState({ records });
    });
    exposeComponentToGlobalScope(this);
  }

  getRecords = (limit, afterCursor) => {
    const {
      currentCompany,
      data,
      periodFrom,
      periodTo,
    } = this.props;

    const params = {
      companyId: currentCompany.id,
      operatorId: data.operator.id,
      periodFrom,
      periodTo,
      limit,
      afterCursor,
    };
    return getManualSwitchOffRecords(params).then(records => {
      const hasLoadedAllRecords = records.length < this.RECORD_CHUNK_SIZE;
      this.setState({ hasLoadedAllRecords });
      return records;
    });
  };

  processRecords = (records, previousRecord) => {
    return records.map((record, i) => {
      const beginTimeFormatted = moment(record.timestamp).format('HH:mm');
      const endTimeFormatted = moment(record.tillTimestamp).format('HH:mm');
      const durationMs = moment(record.tillTimestamp).diff(record.timestamp);
      const durationFormatted = stringifyTimePeriod(durationMs, {
        format: 'numeric',
        padHours: true,
      });

      const previousRecord = previousRecord || records[i - 1];
      const previousRecordBeginTime = previousRecord?.timestamp;
      const showDateLabel = !moment(record.timestamp).isSame(previousRecordBeginTime, 'day');

      return {
        ...record,
        beginTimeFormatted,
        endTimeFormatted,
        durationMs,
        durationFormatted,
        showDateLabel,
      };
    });
  };

  loadAdditionalRecords = () => {
    const { records } = this.state;
    const lastCursor = last(records)?.cursor;

    this.getRecords(this.RECORD_CHUNK_SIZE, lastCursor).then(additionalRecords => {
      const allRecords = [
        ...records,
        ...this.processRecords(additionalRecords, last(records)),
      ];
      this.setState({
        records: allRecords,
      });
    });
  };

  render(){
    const { records, hasLoadedAllRecords } = this.state;
    const {
      className,
      data,
      periodFrom,
      periodTo,
      onClose,
    } = this.props;

    return (
      <Modal
        overrideClassNames={{ modal: className }}
        title="Выключения себя вручную"
        onClose={onClose}>

        Оператор: <b>{getUserFullName(data.operator)}</b><br/>
        Период: <b>{moment(periodFrom).format('D.M.YYYY')}—{moment(periodTo).format('D.M.YYYY')}</b>

        <table className={styles.table}>
          <colgroup>
            <col width="50%"/>
            <col width="25%"/>
            <col width="25%"/>
          </colgroup>
          <thead>
            <tr>
              <th className={cn(styles.tableCell, styles.tableCellHeading)}>
                Причина
              </th>
              <th className={cn(styles.tableCell, styles.tableCellHeading)} colSpan={2}>
                Отсутствие на рабочем месте
              </th>
            </tr>

            <tr>
              <th className={cn(styles.tableCell, styles.tableCellSummary)}>Сводка</th>
              <th className={cn(styles.tableCell, styles.tableCellSummary)}>
                {inflect(data.totalCount, ['раз', 'раза', 'раз'])}
              </th>
              <th className={cn(styles.tableCell, styles.tableCellSummary, styles.tableCellDuration)}>
                {stringifyTimePeriod(moment.duration(data.totalDuration).asMilliseconds(), {
                  format: 'numeric',
                  padHours: true,
                })}
              </th>
            </tr>
          </thead>

          <tbody>
            {records.map(record => (
              <Fragment key={record.id}>
                {record.showDateLabel && (
                  <tr>
                    <th className={cn(styles.tableCell, styles.tableCellDate)} colSpan={3}>
                      {moment(record.timestamp).format('D MMMM YYYY')}
                    </th>
                  </tr>
                )}
                <tr>
                  <td className={cn(styles.tableCell, styles.tableCellComment)}>
                    <span className={styles.recordTitleWrapper}>
                      {record.reasonText && (
                        <Tooltip title={record.reasonText}>
                          <i className={cn('icon-info-circle', styles.recordIconComment)}/>
                        </Tooltip>
                      )}
                      {record.reasonType?.title || '—'}
                    </span>
                  </td>
                  <td className={cn(styles.tableCell, styles.tableCellTime)}>
                    {record.beginTimeFormatted}—{record.endTimeFormatted}
                  </td>
                  <td className={cn(styles.tableCell, styles.tableCellDuration)}>
                    {record.durationFormatted}
                  </td>
                </tr>
              </Fragment>
            ))}
          </tbody>
        </table>

        {!hasLoadedAllRecords && (
          <div className={styles.loadMoreBlock}>
            <span className={uiStyles.link} onClick={this.loadAdditionalRecords}>
              Загрузить еще
            </span>
          </div>
        )}
        <button className={cn(uiStyles.buttonSecondary, styles.closeButton)} onClick={onClose}>
          Закрыть
        </button>
      </Modal>
    );
  }
}
